import { graphql } from '../gql'

export const GetPreWorkAuthorization = graphql(`
	query GetPreWorkAuthorization($orderId: Int!) {
		order(id: $orderId) {
			id
			signatures {
				purpose
				signed
			}
		}
	}
`)

export const TriggerPreWorkAuthorization = graphql(`
	mutation TriggerPreWorkAuthorization($input: NotificationTrigger!) {
		notification {
			trigger(input: $input) {
				ok
			}
		}
	}
`)
